import React from "react";
import type { GetRef, SelectProps } from "antd";

import { Select } from "antd";
import { useTranslation } from "react-i18next";

type Props = Pick<SelectProps, "id" | "aria-describedby" | "aria-invalid" | "aria-required" | "onBlur" | "onFocus"> & {
  value?: string;
  onChange?: (value?: string) => void;
};

type OptionLangKey = "import" | "export" | "internal" | "other";
export const importExportOptionsKeys: Array<OptionLangKey> = ["import", "export", "internal", "other"];

const ImportExportPicker = React.memo(
  React.forwardRef<GetRef<typeof Select>, Props>(function ImportExportPicker({ onChange, value, ...selectProps }, ref) {
    const { t } = useTranslation("translations");
    const options = React.useMemo(() => importExportOptionsKeys.map((key) => ({ value: t(key, { lng: "ru" }), label: t(key) })), [t]);

    return <Select {...selectProps} ref={ref} value={value} options={options} onChange={onChange} allowClear style={{ width: "100%" }} />;
  }),
);

export default ImportExportPicker;
